import { getDirectives, Format, getVariables } from '@nginx/reference-lib';
function toAutocomplete(d) {
  var ret = {
    m: d.module,
    n: d.name,
    d: d.description,
    c: d.contexts.map(c => '`' + c + '`').join(', '),
    s: d.syntax.map(s => "**" + d.name + "** " + s + ";").join('\n')
  };
  if (d.default) {
    ret.v = d.name + " " + d.default + ";";
  }
  return ret;
}
var variables = getVariables(Format.Markdown).map(v => ({
  m: v.module,
  n: v.name,
  d: v.description
}));
export var directives = getDirectives(Format.Markdown).map(toAutocomplete).concat(variables);